export const DeltaXMLColors = {
  CONCRETE: '#F3F3F3',
  FADE_CELERY: '#ACC372',
  CELERY: '#A2C644',
  DARK_CELERY: '#617729',
  FOUNTAIN_BLUE: '#66A1C3',
  OXFORD_BLUE: '#3B495B',
  GRAY: '#878787',
  MULBERRY: '#C8476D',
  PIZAZZ: '#F89200',
  MOJO: '#BA5536',
  DARK_BACKGROUND: '#1E252E',
  LIGHT_BACKGROUND: '#F8F8F8',
  VALENTINE_RED: '#EA4D50',
  BLUE_KOI: '#66A1C3'
}

export const MyDeltaColors = {
  GUN_POWDER: '#404854',
  SILVER: '#C7C7C9',
  GHOST: '#C5CFDB',
  WHITE: '#FFFFFF',
  HAWKES_BLUE: '#CBE5FF',
  BLACK: '#000000',
  LAVENDER_MIST: '#E6EAF0',
  ACTUAL_BLUE: '#0000AA',
  ERROR_RED: '#f7b8b9',
  WARNING_ORANGE: '#FFF4E5',
  WARNING: 'FFA117',
  ORANGE: '#F39211',
  ORANGE_BACKGROUND: '#FFF4E5',
  MERCURY: '#EAEAEA',
  INACTIVE_BORDER: '#CACACA',
  INACTIVE_FOREGROUND: DeltaXMLColors.GRAY,
  FADE_OXFORD: '#3B495B52', 
  FADE_GREY: '#FAFAFA'
}